import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

export const get = (month='') => http.get('feedbacks/', {
  params: {
    month: month,
    version: 2
  }
})
.then(r=>r.data)

export const detail = (id) => http.get('feedbacks/'+id).then(r => r.data)

export const answer = (employeeCode, body) => http.get("feedbacks/answer", {
  params: {
    employeeCode: employeeCode,
    body: body
  }
}) 

